import { IconFilledStar } from "@bared/ui";
import { ComponentProps } from "@ts/components";
import clsx from "clsx";
import React from "react";

export type ReviewsScoreListProps = ComponentProps & {
  handleClick: (star: number) => void;
  handleClear: () => void;
  reviewFilter: number;
  starDistribution: {
    [key: number]: number;
  };
  totalReviews: number;
};

const ReviewsScoreList = ({
  reviewFilter,
  totalReviews,
  starDistribution,
  className,
  handleClick,
  handleClear,
}: ReviewsScoreListProps) => {
  return (
    <div className={clsx(className, "flex flex-col space-y-mini")}>
      <p className="text-caption font-medium leading-caption">
        Overall Ratings:
      </p>
      {Array.from({ length: 5 }).map((_val, index) => {
        const scoreBarPercentage =
          (starDistribution[5 - index] / totalReviews) * 100;
        const selected = reviewFilter === 5 - index;

        return (
          <div
            key={index}
            className="flex cursor-pointer items-center space-x-midi"
            onClick={() => {
              reviewFilter && selected ? handleClear() : handleClick(5 - index);
            }}
          >
            <div className="flex space-x-pico">
              <p className="w-[10px] text-hint">{5 - index}</p>
              <IconFilledStar className="w-[14px]" />
            </div>
            <div
              className={clsx(
                reviewFilter && selected && "outline outline-1",
                "relative h-mini w-full bg-primary-200 md:w-[220px]",
              )}
            >
              <div
                className="absolute h-mini bg-primary"
                style={{ width: `${scoreBarPercentage}%` }}
              />
            </div>
            <p className="min-w-midi text-right text-hint">
              {starDistribution[5 - index]}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default ReviewsScoreList;
